import { z } from 'zod'

/**
 * Companies already on FLOH Venues with a name like the one being signed up,
 * near its address (docs/public-site.spec.md, "Vendor signup"). Only what tells
 * them apart: nobody's people, nothing private.
 */
export const similarVendorListDtoSchema = z.object({
  vendors: z.array(
    z.object({
      id: z.uuid(),
      name: z.string(),
      city: z.string().nullable(),
      state: z.string().nullable(),
    }),
  ),
})

export type SimilarVendorListDto = z.infer<typeof similarVendorListDtoSchema>
